"use client";

import { X } from "lucide-react";

const QUOTES = [
  "Progress is not linear.",
  "Healing isn't forgetting.",
  "Rest is productive.",
  "You are allowed to change your mind.",
  "Asking for help is a form of strength.",
  "Your feelings are valid, even when they're complicated.",
  "Small steps still move you forward.",
  "You don't have to earn rest.",
  "It's okay not to be okay.",
  "Being gentle with yourself is not weakness.",
  "You are not behind. There is no schedule.",
  "Some days, just showing up is enough.",
  "You can hold gratitude and grief at the same time.",
  "Growth often looks like discomfort first.",
  "You are not responsible for other people's reactions to your boundaries.",
  "The hardest seasons often teach the deepest lessons.",
  "You don't have to have it all figured out today.",
  "Self-compassion is not self-indulgence.",
  "It's okay to outgrow people, places, and habits.",
  "You are allowed to take up space.",
  "Letting go is not giving up.",
  "Your pace is your own.",
  "Quiet progress still counts.",
  "You're allowed to start again, as many times as you need.",
  "Peace is a practice, not a destination.",
  "You don't owe anyone an explanation for protecting your peace.",
  "What feels heavy today won't always feel this heavy.",
  "You are more resilient than your worst day.",
  "Stillness is not the same as standing still.",
  "Trust the process, even when you can't see the whole staircase.",
];

function getRandomWisdomQuote(): string {
  return QUOTES[Math.floor(Math.random() * QUOTES.length)];
}

interface WisdomModalProps {
  open: boolean;
  quote: string;
  onClose: () => void;
}

function WisdomModal({ open, quote, onClose }: WisdomModalProps) {
  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Daily wisdom"
      onClick={onClose}
      className="fixed inset-0 z-50 flex animate-in items-center justify-center bg-black/30 px-4 fade-in backdrop-blur-sm duration-300"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-md rounded-2xl bg-[#FBF7F0] px-8 py-10 text-center shadow-2xl"
      >
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute right-4 top-4 flex h-7 w-7 items-center justify-center rounded-full text-v3-body/60 transition-colors hover:bg-v3-secondary/5 hover:text-v3-secondary"
        >
          <X size={15} />
        </button>

        <p className="font-onest text-xs italic text-v3-body">
          Here&apos;s something you may need today.
        </p>
        <p className="mt-5 font-crimsonText text-2xl leading-snug text-v3-secondary sm:text-3xl">
          &ldquo;{quote}&rdquo;
        </p>
      </div>
    </div>
  );
}

export default WisdomModal;
export { getRandomWisdomQuote };
